import { useEffect, useState } from "react";
import { api, type SettingsResponse } from "../../lib/api";

const DEFAULT_TONE = "direct, warm, no fluff";

export default function SettingsCoachTone() {
  const [settings, setSettings] = useState<SettingsResponse | null | "error">(
    null,
  );
  const [tone, setTone] = useState(DEFAULT_TONE);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api
      .settings()
      .then((s) => {
        setSettings(s);
        setTone(s.coach_tone || DEFAULT_TONE);
      })
      .catch(() => {
        setSettings("error");
        setTone(DEFAULT_TONE);
      });
  }, []);

  function save() {
    setSaving(true);
    setSaved(false);
    api
      .postSettings({ coach_tone: tone })
      .then(() => setSaved(true))
      .catch(() => setSaved(false))
      .finally(() => setSaving(false));
  }

  return (
    <div>
      <h2 className="section-title mb-4">Coach tone</h2>

      <div className="card card-pad">
        <label className="field-label" htmlFor="coach-tone">
          Coaching voice
        </label>
        <textarea
          id="coach-tone"
          className="input mt-1"
          style={{ minHeight: 120 }}
          value={tone}
          onChange={(e) => {
            setTone(e.target.value);
            setSaved(false);
          }}
        />
        <p className="muted mt-2">
          This sets the voice of your daily coaching message.
        </p>

        <div className="mt-4 flex items-center gap-3">
          <button
            className="btn-accent"
            onClick={save}
            disabled={saving || settings === null}
          >
            {saving ? "Saving..." : "Save"}
          </button>
          {saved && <span className="text-income">Saved</span>}
        </div>
      </div>
    </div>
  );
}
